module.exports = function() {
  return new Worker("/built/" + "97cfef9034aab9eee6ea.worker.js");
};